import { render, staticRenderFns } from "./ParticaError.vue?vue&type=template&id=3a8a0d3e&"
import script from "./ParticaError.vue?vue&type=script&lang=ts&"
export * from "./ParticaError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports